import { FC } from "react";
import CompanyRegistrationView from "../registration/CompanyRegistrationView";
import FormSectionsNav from "@blanket/components/formSections/FormSectionsNav";
import { IDLE_TIMER_TIMEOUT_MINUTES } from "@/constants/idleTimer";

const HomeView: FC = () => (
  <div className="container-xxl py-4 pb-5">
    <div className="row g-4">
      <div className="col-lg-9 col-xl-8">
        <header className="text-center mb-4">
          <h1 className="h2 fw-semibold mb-2">
            Registrering af virksomhedsforhold
          </h1>
          <p className="text-muted mb-2 mx-auto" style={{ maxWidth: "42rem" }}>
            Brug blanketten til at indberette oprettelse af en ny
            advokatvirksomhed, ændringer i ejerkredsen eller ophør af en
            eksisterende virksomhed. Felter markeret med{" "}
            <span className="text-danger fw-medium">*</span> er obligatoriske.
          </p>
          <p className="text-muted mb-0 mx-auto" style={{ maxWidth: "42rem" }}>
            Du kan ikke gemme en kladde af indberetningen – hvis siden forlades,
            bliver dine ændringer ikke gemt. Siden lukkes automatisk efter{" "}
            {IDLE_TIMER_TIMEOUT_MINUTES} minutters inaktivitet.
          </p>
        </header>
        <CompanyRegistrationView />
      </div>
      <div className="col-lg-3 d-none d-lg-block">
        <FormSectionsNav />
      </div>
    </div>
  </div>
);

export default HomeView;
